import React from "react";

import Header from "../../Layouts/Header";
import Footer from "../../Layouts/Footer";
import NoMatch from "../../../components/Materials/NoMatch";

export default function ExceptionScreen() {
    return (
        <>
            <Header />
            <NoMatch
                text="Unexpected error! Please try again or contact support for assistance."
                onClick={() => {
                    window.location.href = "/";
                }}
            />
            <Footer />
        </>
    )
}